import React from "react";

import { RegularButton, ActionButton } from "colbi_web_ui/lib/components/inputs";

import styles from "./MessageDialog.module.sass";
import dialogStyles from "../../../controllers/App/DialogController/DialogController.module.sass";

const MessageDialog = (props) => {
    const { data, cancel, i18n, confirm } = props;
    const { title, text = [], alert = false, cancelEvent = true } = data;

    return (
        <>
            <div className={dialogStyles["backdrop"]} />
            <div className={dialogStyles["dialog-window"]}>
                <div className={dialogStyles["dialog-header"]}>
                    <h5>{title || i18n`Confirm`}</h5>
                </div>
                <div className={dialogStyles["dialog-content"]}>
                    <div className={styles["root"]}>
                        <div className={styles["content"]}>
                            <h5 className={styles["title"]}>{title}</h5>
                            <div>
                                {text.map &&
                                    text.map((p, i) => (
                                        <p className={styles["text-p-dialog"]} key={i}>
                                            {p}
                                        </p>
                                    ))}
                            </div>
                            {alert ? (
                                <div className={styles["actions"]}>
                                    <ActionButton
                                        className={styles["action-button"]}
                                        type="button"
                                        primary
                                        onClick={() => {
                                            cancelEvent ? cancel && cancel() : confirm && confirm();
                                        }}
                                    >
                                        <strong>{i18n`Confirm`}</strong>
                                    </ActionButton>
                                </div>
                            ) : (
                                <div className={styles["actions"]}>
                                    <RegularButton
                                        className={styles["action-button"]}
                                        type="button"
                                        onClick={() => {
                                            cancel && cancel();
                                        }}
                                    >
                                        <strong>{i18n`Cancel`}</strong>
                                    </RegularButton>
                                    <ActionButton
                                        className={styles["action-button"]}
                                        type="button"
                                        onClick={() => {
                                            confirm && confirm();
                                        }}
                                    >
                                        <strong>{i18n`Confirm`}</strong>
                                    </ActionButton>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MessageDialog;
